<template>
	<div class="container">
		<!-- 头部用户信息 -->
		<div class="header">
			<div class="user-info">
				<div class="avatar">
					<img v-if="userAvatar" :src="userAvatar" alt="Avatar" />
					<img v-else src="@/assets/logo.png" alt="Avatar" />
				</div>
				<div class="greeting" v-if="hasToken">
					<h2>Hi, {{ userName }}</h2>
				</div>
				<div class="greeting" v-else @click="goToLogin">
					<h2>{{ $t("my.register") }}</h2>
				</div>
			</div>
			<div class="language-switch">
				<LanguageSwitch />
			</div>
		</div>

		<!-- Pandapass卡片 -->
		<div class="pandapass-card">
			<img src="@/assets/my/card_bg.png" alt="" />
		</div>

		<!-- 订单管理 -->
		<div class="order-section">
			<div class="order-item" @click="goToOrders('all')">
				<img src="@/assets/my/order_icon.png" alt="" />
				<span>{{ $t("my.order.allOrders") }}</span>
			</div>
			<div class="order-item" @click="goToOrders('Processing')">
				<img src="@/assets/my/payment_icon.png" alt="" />
				<span>{{ $t("my.order.Processing") }}</span>
			</div>
			<div class="order-item" @click="goToOrders('Completed')">
				<img src="@/assets/my/confirm_icon.png" alt="" />
				<span>{{ $t("my.order.Completed") }}</span>
			</div>
			<div class="order-item" @click="goToOrders('AfterSales')">
				<img src="@/assets/my/complete_icon.png" alt="" />
				<span>{{ $t("my.order.afterSales") }}</span>
			</div>
		</div>

		<!-- 设置选项 -->
		<div class="settings-section">
			<div class="setting-item" @click="goToAddress">
				<img src="@/assets/my/address_icon.png" alt="" />
				<span>{{ $t("my.address") }}</span>
			</div>
			<div class="setting-item" @click="goToAI">
				<img src="@/assets/my/ai_icon.png" alt="" />
				<span>{{ $t("my.ai") }}</span>
			</div>
			<div class="setting-item" @click="showCustomerService">
				<img src="@/assets/my/service.png" alt="" />
				<span>{{ $t("my.customerService") }}</span>
			</div>
		</div>

		<!-- 客服二维码弹窗 -->
		<van-popup
			v-model="showQrcodePopup"
			position="center"
			round
			:overlay="true"
			:close-on-click-overlay="true"
			get-container="body"
			class="qrcode-popup"
		>
			<div class="qrcode-content">
				<div class="qrcode-title">{{ $t("my.customerService") }}</div>
				<div class="qrcode-list-wrapper">
					<div class="qrcode-list">
						<div v-for="(image, index) in qrcodeImages" :key="index" class="qrcode-item">
							<div class="qrcode-image-wrapper">
								<img :src="image" :alt="'客服二维码' + (index + 1)" class="qrcode-image" @error="handleImageError" />
							</div>
						</div>
					</div>
				</div>
				<div class="qrcode-tip">{{ $t("my.scanToAdd") }}</div>
			</div>
		</van-popup>

		<!-- 退出按钮 -->
		<div class="exit-section" v-if="hasToken">
			<van-button class="exit-btn" @click="exitApp">
				{{ $t("my.exit") }}
			</van-button>
		</div>
	</div>
</template>

<script>
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import { requireLogin } from "@/utils/auth.js";
export default {
	name: "MyView",
	components: { LanguageSwitch },
	data() {
		return {
			userName: null,
			userInfo: null,
			token: null,
			hasToken: false,
			userAvatar: null,
			showQrcodePopup: false,
			qrcodeImages: [
				require("@/assets/my/pandapass_service_qrcode.png"),
				require("@/assets/my/pandapass_service_qrcode2.png")
			],
		};
	},
	mounted() {
		this.refreshLocalUser();
	},
	activated() {
		// 从其他页面返回时（keep-alive 场景）进行登录有效性校验并重新读取本地登录态
		requireLogin(this);
		this.refreshLocalUser();
	},
	methods: {
		// 读取本地缓存中的 token 与用户信息并同步到页面
		refreshLocalUser() {
			this.token = localStorage.getItem("token") || null;
			this.hasToken = !!this.token;
			this.userInfo = JSON.parse(localStorage.getItem("userInfo")) || null;
			this.userName = this.userInfo ? this.userInfo.nick_name || this.userInfo.nickname || this.userInfo.name : null;
			this.userAvatar = this.userInfo ? this.userInfo.avatar : require("@/assets/avatar.png");
		},
		goToOrders(type) {
			if (!requireLogin(this)) return;
			localStorage.setItem("tab", type);
			this.$router.push({ name: "order-list" });
		},
		goToAddress() {
			if (!requireLogin(this)) return;
			this.$router.push({ name: "address" });
		},
		goToAI() {
			console.log("跳转到AI助手页面");
			this.$toast("AI助手功能开发中...");
		},
		showCustomerService() {
			this.showQrcodePopup = true;
		},
		handleImageError(e) {
			console.error("二维码图片加载失败", e);
			this.$toast("二维码图片加载失败");
		},
		goToLogin() {
			this.$router.push({ name: "login" });
		},
		exitApp() {
			this.$dialog
				.confirm({
					title: this.$t("my.confirmTitle"),
					message: this.$t("my.confirmMessage"),
					confirmButtonText: this.$t("my.confirm"),
					cancelButtonText: this.$t("my.cancel"),
				})
				.then(() => {
					// 退出登录
					localStorage.removeItem("token");
					localStorage.removeItem("userInfo");
					setTimeout(() => {
						this.$router.push("/login");
					}, 100);
				})
				.catch(() => {
					// 用户取消
				});
		},
	},
};
</script>

<style scoped lang="scss">
.container {
	background: #f5f5f5;
	padding: 20px 16px 80px;

	overflow: hidden auto;
	height: calc(100vh - 168px - env(safe-area-inset-bottom));
}

.header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 20px;
	align-items: flex-start;

	.user-info {
		display: flex;
		align-items: center;
		gap: 12px;
		flex: 1;

		.avatar {
			width: 50px;
			height: 50px;
			border-radius: 50%;
			background: #e0e0e0;
			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;
			flex-shrink: 0;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.greeting {
			h2 {
				font-size: 20px;
				font-weight: bold;
				color: #333;
				margin: 0;
				line-height: 1.2;
				min-height: 24px;
			}
		}
	}

	.language-switch {
		flex-shrink: 0;
		// LanguageSwitch 组件样式
	}
}

.pandapass-card {
	width: 100%;
	margin: 0 auto 12px;
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
}

.order-section {
	background: white;
	border-radius: 16px;
	padding: 20px 24px;
	margin-bottom: 16px;
	display: flex;
	justify-content: space-between;
	box-shadow: 0px 0px 31px 0px rgba(186, 189, 202, 0.4);

	.order-item {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 8px;
		cursor: pointer;
		transition: transform 0.2s ease;
		flex: 1;
		min-width: 0;

		&:hover {
			transform: translateY(-2px);
		}

		img {
			width: 35px;
			height: 35px;
		}

		span {
			font-size: 12px;
			color: #333;
			font-weight: 500;
			text-align: center;
			line-height: 1.2;
			min-height: 28px;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
		}
	}
}

.settings-section {
	background: white;
	border-radius: 16px;
	padding: 20px;
	margin-bottom: 20px;

	.setting-item {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 12px 0;
		cursor: pointer;
		transition: background-color 0.2s ease;
		min-height: 48px;

		&:hover {
			background-color: #f8f8f8;
			border-radius: 8px;
			padding-left: 12px;
			padding-right: 12px;
			margin-left: -12px;
			margin-right: -12px;
		}

		&:not(:last-child) {
			border-bottom: 1px solid #f0f0f0;
		}

		img {
			width: 46px;
			height: 46px;
		}

		span {
			font-size: 16px;
			color: #333;
			font-weight: 500;
			flex: 1;
			line-height: 1.2;
		}
	}
}

.exit-section {
	.exit-btn {
		width: 100%;
		height: 50px;
		background: #eb2d16;
		border: none;
		border-radius: 12px;
		color: white;
		font-size: 16px;
		font-weight: bold;
		cursor: pointer;
		transition: background-color 0.2s ease;
		min-width: 80px;

		&:hover {
			background: #d4240f;
		}
	}
}

.qrcode-popup {
	:deep(.van-popup) {
		max-width: 400px;
	}

	.qrcode-content {
		padding: 25px 15px;
		text-align: left;
		width: calc(90vw - 30px);
		max-width: 380px;
		overflow: hidden;

		.qrcode-title {
			font-size: 18px;
			font-weight: bold;
			color: #333;
			margin-bottom: 20px;
			text-align: center;
		}

		.qrcode-list-wrapper {
			margin-bottom: 15px;
			width: 100%;
			overflow: hidden;
			margin-left: 0;
			margin-right: auto;

			.qrcode-list {
				display: flex;
				align-items: center;
				gap: 0;
				overflow-x: auto;
				overflow-y: hidden;
				scrollbar-width: none;
				-ms-overflow-style: none;
				scroll-behavior: smooth;

				&::-webkit-scrollbar {
					display: none;
				}

				.qrcode-item {
					flex-shrink: 0;
					padding: 10px 0;
					width: 70%;
					margin: 0 12px;

					.qrcode-image-wrapper {
						display: flex;
						justify-content: center;
						align-items: center;
						background: #fff;
						border-radius: 8px;
						box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
						padding: 10px;
						width: calc(100% - 20px);

						.qrcode-image {
							width: 100%;
							aspect-ratio: 1;
							object-fit: contain;
							border-radius: 8px;
							display: block;
						}
					}
				}
			}
		}

		.qrcode-tip {
			font-size: 14px;
			color: #666;
			line-height: 1.5;
			text-align: center;
		}
	}
}

</style>
